
















































































import {Component, Prop, Watch} from "vue-property-decorator"
import AbpBase from "../../../../lib/abpbase"
import {SavePropaganda} from "@/api/propaganda"

@Component
export default class AddOrEdit extends AbpBase{
	@Prop({type:Boolean,default:false}) value:Boolean
	@Prop() data:any
	@Prop({type:Array}) types:Array<any> //父组件传来的所有宣教分类
	baseUrl = XMLHTTP_BASEURL
	t = this.types
	imgs:any = []
	type:Array<any> = []
	model:any = {
		resourceTitle: '',
		type: '',
		uploadType: 0,
		corerImagePath: '',
		contentImagePath: ''
	}
	@Watch('model.uploadType')
	uploadTypeChange(){
		this.model.contentImagePath = ''
		this.imgs = []
	}
	created(){
		console.log(this.data.data)
		if (this.data.mode === 'edit') {
			this.model = Object.assign({}, this.data.data)
			this.$nextTick(()=>{
				//  直接给editor赋值时可能editor还没有生成
				//  先赋值123 是因为给 contentImagePath 赋相同的值不会触发html重绘
				this.model.contentImagePath = `<p>123</p>`
				this.model.contentImagePath = this.data.data.contentImagePath
			})
			if (this.model.uploadType === 0) {
				this.imgs = this.model.contentImagePath.split(';')
			}
			this.type = this.model.type.split(';')
		}
	}
	save(){
		(this.$refs.form as any).validate(async (valid:boolean)=>{
			if(valid){
				if (!this.type.length) {
					this.$Message.warning("请选择宣教分类！")
					return
				}
				if (!this.model.corerImagePath) {
					this.$Message.warning("请上传封面！")
					return
				}
				if (this.model.uploadType === 0) {
					this.model.contentImagePath = this.imgs.join(';')
					if (!this.model.contentImagePath) {
						this.$Message.warning("请上传封面！")
						return
					}
				} else if (!this.model.contentImagePath) {
					this.$Message.warning("请填写内容！")
					return
				}
				this.model.type = this.type.join(';')
				let res = await SavePropaganda(this.model)
				if (res.status === 1) {
					this.$emit('save-success')
				}
			}
		})

	}
	cancel(){
		this.$emit('input', false)
	}
	// 上传封面成功
	handleSuccess (res:any, file:any) {
		this.model.corerImagePath = this.baseUrl + res.result.objects.imageAddress
	}
	//  上传内容成功
	handleSuccess1 (res:any, file:any) {
		this.imgs.push(this.baseUrl + res.result.objects.imageAddress)
	}
	handleFormatError (file:any) {
		this.$Message.warning("请选择'jpg','jpeg','png'格式文件！");
	}
	handleMaxSize (file:any) {
		this.$Message.warning("请选择小于3M文件！");
	}
	get dialogTitle() {
		return this.data.mode === 'add' ? '新增' : '编辑'
	}
	visibleChange(value:boolean){
		if(!value){
			this.$emit('input',value);
		}
	}
	rules = {
		resourceTitle: [{required: true, message: '请输入', trigger: 'blur'}],
		uploadType: [{required: true, message: '选择', trigger: 'blur'}]
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/education/warehouse/parts/addOrEdit.vue